import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.2) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function GuaranteeSection() {
  const {
    ref,
    inView
  } = useInView();
  return <section className="py-16 lg:py-20" style={{
    backgroundColor: '#0A1929'
  }} ref={ref} data-id="element-73">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-74">
        <div className="flex flex-col sm:flex-row items-center gap-8 p-8 lg:p-10 rounded-2xl transition-all duration-700" style={{
        backgroundColor: 'rgba(201,168,76,0.06)',
        border: '1px solid rgba(201,168,76,0.3)',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-75">
          {/* Shield icon */}
          <div className="flex-shrink-0" data-id="element-76">
            <div className="w-20 h-20 rounded-full flex items-center justify-center text-4xl" style={{
            backgroundColor: 'rgba(201,168,76,0.15)',
            border: '2px solid rgba(201,168,76,0.4)'
          }} data-id="element-77">
              🛡️
            </div>
          </div>

          {/* Content */}
          <div data-id="element-78">
            <h3 className="font-heading font-bold text-xl mb-3" style={{
            color: '#C9A84C'
          }} data-id="element-79">
              Garantía Total de 30 Días
            </h3>
            <p className="font-body text-sm leading-relaxed" style={{
            color: '#A8C0D8'
          }} data-id="element-80">
              Si en 30 días no ves cómo tu experiencia se convierte en un
              servicio vendible,{' '}
              <strong style={{
              color: '#E2C97E'
            }} data-id="element-81">
                te devuelvo cada euro
              </strong>
              . Sin preguntas. Sin formularios. Sin burocracia.
            </p>
          </div>
        </div>
      </div>
    </section>;
}